<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Faktury'" [name]="'Historia przelewów'"></app-breadcrumb>
<div class="invoice-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

      <app-month-picker
        class="invoice-list-filter"
        label="Miesiąc rozliczeniowy" [required]="false"
        name="billingMonth" [(ngModel)]="initialFilters.billingMonth"
      ></app-month-picker>

      <app-dict
        [multiple]="true" label="Akcja"
        class="invoice-list-filter"
        dictType="invoice_status"
        [(ngModel)]="initialFilters.in$status" name="in$status"
      ></app-dict>


    </form>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>
    <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report" mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">
    <table mat-table [dataSource]="items">
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Akcja </th>
        <td mat-cell *matCellDef="let element">
          {{element.action?.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="billingMonth">
        <th mat-header-cell *matHeaderCellDef> Miesiąc rozliczeniowy </th>
        <td mat-cell *matCellDef="let element">
<!--          <a class="default-link" [routerLink]="['/faktury/szczegoly', element?.id]">-->
            {{element.billingMonth}}
<!--          </a>-->
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
        <td mat-cell *matCellDef="let element">
          {{element.requestedAt | date:'y-MM-dd HH:mm'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.calledBy">
            <div class="circular-image">
              <img class="circular-image small-avatar job-list-avatar"
                   [src]="'/rest/sso/api/user/' + element.calledBy.uuid + '/avatar'" (error)="onImgError($event)"
                   alt="Zdjęcie"/>
            </div>
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.calledBy.uuid]">{{element.calledBy.firstName}} {{element.calledBy.lastName}}</a>
          </ng-container>
          <ng-container *ngIf="!element.calledBy">
            System
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
            {{element.status.name}}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="downloadReportFile(element)" >Pobierz raport</button>
          </mat-menu>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
